import { ThemeProperties } from '../../core';

export interface ChipTheme {
	baseBorderRadius: string;
	baseGap: string;
	baseRemoveGap: string;
	basePaddingInline: string;
	baseRemovePaddingInlineEnd: string;

	outlinedBorderColor: string;
	outlinedTextColor: string;
	outlinedIconColor: string;
	outlinedRemoveIconColor: string;

	defaultBackground: string;
	defaultTextColor: string;
	successBackground: string;
	successTextColor: string;
	infoBackground: string;
	infoTextColor: string;
	warningBackground: string;
	warningTextColor: string;
	dangerBackground: string;
	dangerTextColor: string;
	brandDarkBackground: string;
	brandDarkTextColor: string;
	brandLightBackground: string;
	brandLightTextColor: string;
	neutralLightBackground: string;
	neutralLightTextColor: string;
	neutralDarkBackground: string;
	neutralDarkTextColor: string;

	smallHeight: string;
	smallText: string;

	mediumHeight: string;
	mediumText: string;
}

export const theme = new ThemeProperties('chip');
